module.exports = __webpack_public_path__ + "media/images/pic/home/pride-8e440ae2fa0f7f2cce77879ab3c6f60f.webp";